<template>
  <AuthTree :idKey="rbac.$state.models.user[0].id"
            sourceUrlKey="users"
            targetUrlKey="roles"
            resultKey="organizations"
            :checkStrictly="checkStrictly">
  </AuthTree>
</template>

<script setup lang="ts">
import { useRbacStore } from '../../DefaultRbacPagePlugin'
import AuthTree from '../menu/AuthTree.vue'

const checkStrictly = true

const rbac = useRbacStore()


</script>

<style lang="less" scoped>
:deep(.ant-table) {
  height: 76.4vh;
}
</style>
